import styled, { css } from 'styled-components';
import { ReactComponent as ArrowSvg } from './arrow.svg';
export const Arrow = styled(ArrowSvg)``;
export const ArrowVert = styled(ArrowSvg)``;
export const Block = styled.div`
	background: rgba(9, 21, 38, 0.85);
	box-shadow: 0px 12px 24px rgba(57, 78, 127, 0.2);
	border-radius: 8px;
	padding: 16px 16px;
	color: #ffffff;
	max-width: 240px;
	font-size: 16px;
	line-height: 22px;
`;
export const Corner = styled.div``;
export const Wrap = styled.div<{ show?: Boolean; $backgroundColor?: string }>`
	z-index: 1000;
	${({ $backgroundColor }) =>
		$backgroundColor &&
		css`
			${Corner} path {
				fill: ${$backgroundColor};
				fill-opacity: 1;
			}
		`}
	${({ show }) =>
		!show &&
		css`
			visibility: hidden;
			pointer-events: none;
		`};
	&[data-popper-placement^='bottom'] {
		padding-top: 12px;
		${Corner} {
			left: 0px;
			height: 12px;
			width: 25px;
			display: flex;
			top: 0;
			svg {
				transform: rotate(180deg);
			}
		}
		${Corner} ${ArrowVert} {
			display: none;
		}
	}
	&[data-popper-placement^='top'] {
		padding-bottom: 12px;
		padding-top: 52px;
		${Corner} {
			left: 0px;
			height: 12px;
			width: 25px;
			display: flex;
		}
		${Corner} ${ArrowVert} {
			display: none;
		}
	}
	&[data-popper-placement^='right'] {
		padding-left: 12px;
		${Corner} {
			left: 0px;
			height: 25px;
			width: 12px;
		}
		${Corner} ${Arrow} {
			display: none;
		}
	}
`;
